import { formState } from "../../../modules/form/FormState";
import { ValidateFields } from "../../../modules/form/ValidateFields";
import { serviceFormPreregistro } from "../../services/PreregistroService";
import { getUbicationData } from "../interfaces/UbicationInterface";
import { getUserData } from "../interfaces/UserInterface";
import { getUtmData } from "../interfaces/UtmInterface";
import { getDeviceType } from "../variables/globalVariables";
import { ContactForm } from "./ContactForm";
/**
 * @description Class responsible for handling the form submission.
 */
export class PreregistroForm {
    // Constructor where the form state is initialized and methods are bound to the correct context
    constructor(formState) {
        this.formState = formState;
        this.formName = '';
        this.ID = 0;
        // Bind methods to the correct context (this)
        this.submitForm = this.submitForm.bind(this);
        this.setPreregistroForm = this.setPreregistroForm.bind(this);
    }
    /**
     * Method responsible for submitting the form with the gathered information.
     */
    submitForm() {
        // Select the form using the provided ID
        var _a, _b;
        this.formName = this.formState.manageState('formName');
        this.form = document.querySelector(this.formName);
        let validateForm = new ValidateFields(this.formState);
        let readyToSendForm = validateForm.validateSubmitForm(this.form, 'Preregistro');
        if (readyToSendForm) {
            if (this.form.querySelector('.btn-form')) {
                this.form.querySelector('.btn-form').disabled = true;
            }
            (_a = this.form.querySelector('#sendText')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
            (_b = this.form.querySelector('#sendingText')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
            // Get form data
            const sendFormUser = new ContactForm(this.formState);
            sendFormUser.loadSendForm(this.form);
            let userData = getUserData() || sendFormUser.setUserForm(this.form);
            let utmData = getUtmData() || sendFormUser.setUtmForm();
            let ubicationData = getUbicationData();
            let preregistroData = this.setPreregistroForm(this.form);
            let formData = { ...userData, ...preregistroData, ...utmData, ...ubicationData };
            // Instantiate the service to send the form data
            serviceFormPreregistro.sendLead(formData);
        }
    }
    setPreregistroForm(form) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        // Define the context path based on the URL
        let contextPath = window.location.pathname.split('/')[1] + '/';
        let contextOrigen = this.formState.manageState('origen');
        let contextAd = this.formState.manageState('anuncio');
        let contextReference = this.formState.manageState('referrer');
        // Return an object with the extracted form data and context information
        return {
            IngresosFamiliares: (_a = form.querySelector('[name="ingreso"]')) === null || _a === void 0 ? void 0 : _a.value,
            budget: (_b = form.querySelector('[name="min_budget"]')) === null || _b === void 0 ? void 0 : _b.value,
            max_budget: (_c = form.querySelector('[name="max_budget"]')) === null || _c === void 0 ? void 0 : _c.value,
            contact: 2,
            subsidy: (_d = form.querySelector('[name="subsidy_method"]')) === null || _d === void 0 ? void 0 : _d.value,
            userHasMortgage: (_e = form.querySelector('[name="mortgage_method"]')) === null || _e === void 0 ? void 0 : _e.value,
            tiempo_compra: (_f = form.querySelector('[name="purchase_time"]:checked')) === null || _f === void 0 ? void 0 : _f.value,
            ciudad: (_g = form.querySelector('[name="city"]')) === null || _g === void 0 ? void 0 : _g.value,
            zona_interes: (_h = form.querySelector('[name="zona"]')) === null || _h === void 0 ? void 0 : _h.value,
            sector_interes: (_j = form.querySelector('[name="sector"]')) === null || _j === void 0 ? void 0 : _j.value,
            rango_de_precio: (_k = form.querySelector('[name="rango_de_precio"]')) === null || _k === void 0 ? void 0 : _k.value,
            field_typology_id: this.ID,
            contextPath: contextPath,
            contextDevice: getDeviceType(),
            contextAd: contextAd,
            origen: contextOrigen,
            contextReference: contextReference,
        };
    }
}
// Exporting the class for use in other modules
export const sendFormPreregistro = new PreregistroForm(formState);
window.sendPreregistro = sendFormPreregistro.submitForm;
